'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import z from 'zod';
import { Admonition, admonitionSchema } from './admonition';

export const Note = (props: z.input<typeof admonitionSchema>) => {
  const t = useTranslations();
  const { children } = props;

  return (
    <Admonition severity="info" title={t('mdx:alert:note')}>
      {children}
    </Admonition>
  );
};
